<template>
	<div v-if="date" :class="[settings.variants[variant].wrapper]">
		<span :class="settings.variants[variant].day">
			{{ day }}
		</span>
		<span :class="settings.variants[variant].month">
			{{ month }}
		</span>
	</div>
</template>

<script setup>
import {computed} from 'vue';
import {useDateFormat} from '@vueuse/core';
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkDate');

const props = defineProps({
	variant: {
		type: String,
		default: 'default',
		required: false,
	},
	/** Needs to be the format YYYY-MM-DD HH:mm:ss */
	date: {
		type: String,
		required: true,
	},
});

const day = computed(() => {
	return useDateFormat(props.date, 'DD').value;
});

const month = computed(() => {
	return useDateFormat(props.date, 'MMM').value;
});
</script>
